import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  activatePartnerSalesContract,
  type ActivatePartnerSalesResponse
} from '@bliks-io/contracts';
import { apiClient } from '@/api/client';
import { orgMemberKeys } from '@/api/query-keys';

/**
 * "Activate for Sales": link a partner user to a HubSpot contact (existing or
 * newly created) so it can submit leads. On success the team list is invalidated
 * so the user flips to sales-enabled (the action disappears) and the HubSpot
 * employees list refreshes (a newly created contact appears there).
 */
export function useActivatePartnerSales() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: orgMemberKeys.activateSalesMutation(),
    mutationFn: async (userId: string): Promise<ActivatePartnerSalesResponse> => {
      const { data } = await apiClient.post<ActivatePartnerSalesResponse>(
        activatePartnerSalesContract.path.replace(':userId', userId)
      );
      return data;
    },
    // Returned, so the row stays busy until the refetched list shows the new status.
    onSuccess: () => queryClient.invalidateQueries({ queryKey: orgMemberKeys.all })
  });
}
